/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class LocalizationModel {
        key: string;
        items: LocalizationItemModel[];
        changed: boolean;
    }

    export class LanguageModel {
        code: string;
        name: string;
    }

    export class LocalizationItemModel {
        languageCode: string;
        text: string;
    }

    export class TranslationPair {
        key: string;
        value: string;
    }
}